import { format } from 'date-fns'
import locale from 'date-fns/esm/locale/ru/index.js'

export const formatDate = (value: Date | string, template: string) => {
  const date = typeof value === 'string' ? new Date(value) : value

  return format(date, template, { locale })
}
